var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",class:_vm.darkmode || 'grey lighten-5',attrs:{"flat":""}},[_c('Table',{attrs:{"loading":_vm.loading,"myScheduleOnly":""},on:{"loading":value => (_vm.loading = value)}}),_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":6}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }